import { withTranslation } from "../translation";
import styles from "./SelectedFacets.css";
import PropTypes from "prop-types";
import { useRef, useMemo } from "react";
import { useSelectedFacets } from "../../state/hooks/useSelectedFacets";
import classnames from "classnames";
import {
  HORIZONTAL_SCROLL_MASK_BOTH,
  HORIZONTAL_SCROLL_MASK_LEFT,
  HORIZONTAL_SCROLL_MASK_RIGHT,
  useHorizontalScrollMask,
} from "../hooks/useHorizontalScrollMask";

export const SelectedFacets = ({ formatTranslation }) => {
  const { displayedFacetValues, changeMultiFacet, clearAlwaysApply } =
    useSelectedFacets();

  const containerRef = useRef(null);
  const { canScrollLeft, canScrollRight, maskState } =
    useHorizontalScrollMask(containerRef);
  const reverseSelectedFacetValues = useMemo(
    () => [...(displayedFacetValues || [])].reverse(),
    [displayedFacetValues],
  );

  if (!displayedFacetValues || displayedFacetValues.length === 0) {
    return null;
  }

  const onClick = (facetValue) => {
    if (facetValue.facetId === "currentprice") {
      clearAlwaysApply("currentprice");
    } else {
      changeMultiFacet([
        {
          facetId: facetValue.facetId,
          valueId: facetValue.id,
          isSelected: false,
        },
      ]);
    }
  };

  const isScrollable = canScrollLeft || canScrollRight;

  return (
    <div
      ref={containerRef}
      className={classnames(styles.container, {
        [styles.containerScrollable]: isScrollable,
        [styles.maskLeft]: maskState === HORIZONTAL_SCROLL_MASK_LEFT,
        [styles.maskRight]: maskState === HORIZONTAL_SCROLL_MASK_RIGHT,
        [styles.maskBoth]: maskState === HORIZONTAL_SCROLL_MASK_BOTH,
      })}
    >
      {reverseSelectedFacetValues.map((facetValue) => (
        <div key={facetValue.id} className={styles.facet}>
          <span className={styles.name}>{facetValue.name}</span>
          <button
            className={styles.close}
            type="button"
            onClick={() => onClick(facetValue)}
            aria-label={formatTranslation("accessibility_label_close")}
          />
        </div>
      ))}
    </div>
  );
};

SelectedFacets.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(SelectedFacets);
